import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DiscProjectEditDialog from '../../disc/components/dialog/disc-project-edit-dialog';
import { toggleHeaderMenuExpanded } from '../../settings/actions/application-actions';

class DiscViewHeader extends Component {
	constructor(props) {
		super(props);
		this.state={
			isDialogOpen: false
		}
		this.openAddDiscDialog = this.openAddDiscDialog.bind(this)
        this.onDialogClose = this.onDialogClose.bind(this)
	}

	openAddDiscDialog() {
		this.setState({isDialogOpen:true})
	}
	onDialogClose(){
		this.setState({isDialogOpen:false})
	}


	render() {
		const { toggleHeaderMenuExpanded,disc } = this.props;

		return (
			<header className="header-flex-container header-default">
				<div className="header-flex-left">
					<div className="hamburger-menu-container" onClick={toggleHeaderMenuExpanded}>
						<div className="hamburger-menu">
						</div>
						<div className="header-label">Menu</div>
					</div>
					<div className="header-item logo" onClick={this.props.navigateHome}>
						&nbsp;
						<span className="hidden">iMemories&reg;</span>
					</div>
				</div>
				<div className="header-flex-right">

					<div className="header-item header-item-right" onClick={this.openAddDiscDialog}>
						<div className="header-icon add-to-album"/>
						<div className="header-label">Add New Disc</div>
					</div>
					{/*<div className="header-item header-item-right">*/}
						{/*<div className="header-icon select" />*/}
						{/*<div className="header-label">Select</div>*/}
					{/*</div>*/}
					{/*<div className="header-item header-item-right">*/}
						{/*<div className="header-label">Sort By</div>*/}
						{/*<div className="header-icon header-caret caret" />*/}
					{/*</div>*/}
				</div>
				{this.state.isDialogOpen &&
				<DiscProjectEditDialog isOpen={this.state.isDialogOpen} onClose={this.onDialogClose}/>
                }

			</header>
		);
	}
}

DiscViewHeader.propTypes = {
	toggleHeaderMenuExpanded: PropTypes.func,
	navigateHome: PropTypes.func
};
const mapStateToProps = state => {
    return {
        disc: state.disc,
    };
};
const mapDispatchToProps = dispatch => {
	return {
		toggleHeaderMenuExpanded: (evt) => {
			dispatch(toggleHeaderMenuExpanded());
			if(evt) evt.stopPropagation();
		}
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscViewHeader);



// WEBPACK FOOTER //
// ./src/header/components/disc-view-header.jsx